export const bannerTokens = {
  banner: {
    root: {
      background: '{info.background}',
      borderRadius: '0'
    },
    draft: {
      background: '{surface.100}'
    },
    warn: {
      background: '{warn.background}'
    },
    error: {
      background: '{danger.background}'
    },
    success: {
      background: '{success.background}'
    },
    highlight: {
      background: '{info.background}',
      borderColor: '{primary.300}',
      borderRadius: '{borderRadius.lg}',
      draft: {
        background: '{surface.100}',
        borderColor: '{surface.300}'
      },
      warn: {
        background: '{warn.background}',
        borderColor: '{yellow.300}'
      },
      error: {
        background: '{danger.background}',
        borderColor: '{red.300}'
      },
      success: {
        background: '{success.background}',
        borderColor: '{green.300}'
      }
    }
  }
};

export type BannerTokens = typeof bannerTokens;
